(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-related-products"]) return;
  try {
    
  var loadProductRecommendationsIntoSection = function() {
    // Look for an element with class 'product-recommendations'
    var productRecommendationsSection = document.querySelector(".product-recommendations");
    var recipeTile = productRecommendationsSection.querySelector(".featured-product-callout-wrapper");
    var recipeTileHtml = '';

    if (productRecommendationsSection === null) {
      return;
    }

    if (recipeTile !== null) {
      recipeTileHtml = recipeTile.innerHTML;
    }

    // Read product id from data attribute
    var productId = productRecommendationsSection.dataset.productId;

    // Read limit from data attribute
    var limit = productRecommendationsSection.dataset.limit;

    // Build request URL
    var requestUrl = "/recommendations/products?section_id=product-related-products&limit="+limit+"&product_id="+productId;

    // Create request and submit it using Ajax
    var request = new XMLHttpRequest();

    request.open("GET", requestUrl);
    request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        container.innerHTML = request.response;

        if (recipeTileHtml) {
          var recipeTile = container.querySelector(".featured-product-callout-wrapper");

          if (recipeTile !== null) {
            recipeTile.innerHTML = recipeTileHtml;
          }
        }

        productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      }
    };

    request.send();
  };

                                                        
  // If your section has theme settings, the theme editor
  // reloads the section as you edit those settings. When that happens, the
  // recommendations need to be fetched again.
  // See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
  document.addEventListener("shopify:section:load", function(event) {
    if (event.detail.sectionId === "product-related-products") {
      loadProductRecommendationsIntoSection();
    }
  });

  // Fetching the recommendations on page load
  loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
